import angular from 'angular';

(function() {
  'use strict';
  angular.module('app.core').factory('InvoiceUpload', InvoiceUploadData);

  InvoiceUploadData.$inject = ['$translate', 'CONF', 'Seller', 'LegalEntity', 'PrincipalDetail'];

  /* @ngInject */
  function InvoiceUploadData($translate, CONF, Seller, LegalEntity, PrincipalDetail) {
    InvoiceUpload.prototype = {
      build: build,
      buildEmpty: buildEmpty,
      getTransMode: getTransMode,
      getStatus: getStatus,
      getPdfLink: getPdfLink,
      isUploadMail: isUploadMail,
      isWebInput: isWebInput,
      isDraft: isDraft,
      getInputXmlLink: getInputXmlLink
    };

    function InvoiceUpload(invoiceUploadData) {
      if (!invoiceUploadData) {
        this.buildEmpty();
      } else {
        this.build(invoiceUploadData);
      }
    }

    return InvoiceUpload;

    /////////////////////

    function buildEmpty() {
      this.seller = new LegalEntity();
      this.buyer = new LegalEntity();
      this.transmissionMode = null;
      this.creationDate = null;
      this.updateDate = null;
      this.functionalStatus = null;
      this.refDoc = null;
      this.refKissId = null;
      this.refKissName = null;
      this.techId = null;
      this.batchEpdf = false;
    }

    function build(invoiceUploadData) {
      this.seller = new LegalEntity(invoiceUploadData.seller);
      this.buyer = new LegalEntity(invoiceUploadData.buyer);
      this.principal = new PrincipalDetail(invoiceUploadData.principal);
      this.transmissionMode = invoiceUploadData.transmissionMode || null;
      this.creationDate = invoiceUploadData.creationDate;
      this.updateDate = invoiceUploadData.updateDate;
      this.functionalStatus = invoiceUploadData.functionalStatus || null;
      this.refDoc = invoiceUploadData.refDoc || null;
      this.refKissId = invoiceUploadData.refKissId || null;
      this.refKissName = invoiceUploadData.refKissName || null;
      this.techId = invoiceUploadData.techId || null;
      this.batchEpdf = invoiceUploadData.batchEpdf || false;
    }

    function getTransMode() {
      return $translate.instant('kiss_invoice.transmission_mode.' + this.transmissionMode);
    }

    function getStatus() {
      return $translate.instant('kiss_invoice.functionalStatus.' + this.functionalStatus);
    }

    function getPdfLink() {
      return CONF.apiContext + CONF.apiBaseUrl + '/v1/invoices/upload/' + this.techId + '?disposition=INLINE';
    }

    function isUploadMail() {
      return this.transmissionMode === 'upload' || this.transmissionMode === 'email';
    }

    function isWebInput() {
      return this.transmissionMode === 'webinput';
    }

    function isDraft() {
      return this.functionalStatus === 'draft';
    }

    function getInputXmlLink() {
      return CONF.apiContext + CONF.apiBaseUrl + '/v1/files/' + this.refKissId + '?disposition=INLINE';
    }
  }
})();
